$( document ).ready(function() {

    var height = $(window).scrollTop();

    // if(height > 0){
    //     $('.header').addClass('header-scroll');
    // } else{
    //     $('.header').removeClass('header-scroll');
    // }

    // Scroll Top
    $(window).scroll(function() {
        let widgetNav = $('.widget-home-page');
        let height = $(window).scrollTop();

        $('.menu-item-has-children-active').removeClass('menu-item-has-children-active');
        $('.sub-menu-active').removeClass('sub-menu-active');

        // if(height > 0){
        //     $('.header').addClass('header-scroll');
        // } else{
        //     $('.header').removeClass('header-scroll');
        // }

        if(widgetNav) {
            let banerHeight = $('.baner-top-height').height();
            let widgetHeight = widgetNav.height();
            if(height > banerHeight + widgetHeight) {
                widgetNav.css({
                    'opacity' : '1',
                    'visibility': 'visible'
                });
            } else {
                widgetNav.css({
                    'opacity' : '0',
                    'visibility': 'hidden'
                });
            }
        }
    });

    // $('.menu-item-has-children a').on('click', function(event) {
    //     if($(this).parent().hasClass('menu-item-has-children')) {
    //         event.preventDefault();
    //         $(this).parent().toggleClass('menu-item-has-children-active');
    //         $(this).parent().children('.sub-menu').toggleClass('sub-menu-active');
    //     }
    // });

});
